<template>
  <div>
    asdfasdfasdf as
  </div>
</template>

<script>
  export default {
    name: "Newdisk.vue"
  }
</script>

<style scoped>

</style>
